import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { schedulesApi, sellersApi, type Schedule, type SellerListItem } from '../lib/api';
import { useAuth } from '../lib/auth';
import { joinDays } from '../lib/weekdays';
import { useBasePath, withBase } from '../lib/basePath';

export default function SchedulesList() {
  const { user } = useAuth();
  const base = useBasePath();
  const [list, setList] = useState<Schedule[] | null>(null);
  const [sellers, setSellers] = useState<SellerListItem[]>([]);
  const [filterSeller, setFilterSeller] = useState<number | ''>('');
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (user?.role === 'admin') {
      sellersApi.list().then((r) => setSellers(r.sellers)).catch(() => { /* noop */ });
    }
  }, [user]);

  useEffect(() => {
    schedulesApi.list(filterSeller || undefined)
      .then((r) => setList(r.schedules))
      .catch((e) => setErr(String(e?.message ?? e)));
  }, [filterSeller]);

  function sellerLabel(id: number) {
    const s = sellers.find((x) => x.id === id);
    return s ? (s.display_name || s.login) : `#${id}`;
  }

  if (err) return <div className="container"><div className="error">{err}</div></div>;
  if (!list) return <div className="container"><p className="muted">Загрузка…</p></div>;

  return (
    <div className="container">
      <div className="page-head">
        <h2>Расписания отгрузок</h2>
        <Link to={withBase(base, '/schedules/new')} className="btn primary">+ Новое расписание</Link>
      </div>

      {user?.role === 'admin' && (
        <div className="row" style={{ marginBottom: 16 }}>
          <label className="muted">Продавец:</label>
          <select
            value={filterSeller}
            onChange={(e) => setFilterSeller(e.target.value ? Number(e.target.value) : '')}
            style={{ padding: 6 }}
          >
            <option value="">Все</option>
            {sellers.map((s) => (
              <option key={s.id} value={s.id}>{s.display_name || s.login}</option>
            ))}
          </select>
        </div>
      )}

      {list.length === 0 ? (
        <p className="muted">Расписаний нет. Создай первое.</p>
      ) : (
        <table className="grid">
          <thead>
            <tr>
              <th>#</th>
              <th>Название</th>
              {user?.role === 'admin' && <th>Продавец</th>}
              <th>Дни отгрузок</th>
              <th>Время отгрузки</th>
              <th>Дедлайн</th>
              <th>По умолчанию</th>
            </tr>
          </thead>
          <tbody>
            {list.map((s) => (
              <tr key={s.id}>
                <td>{s.id}</td>
                <td><Link to={withBase(base, `/schedules/${s.id}`)}>{s.name}</Link></td>
                {user?.role === 'admin' && <td>{sellerLabel(s.seller_id)}</td>}
                <td>{joinDays(s.ship_days)}</td>
                <td>{s.ship_time_msk}</td>
                <td>
                  {s.windows && s.windows.length > 0
                    ? `${s.windows.length} конкретных дат`
                    : (s.deadline_anchor === 'relative'
                        ? `за ${s.deadline_offset_h} ч до отгрузки`
                        : `${joinDays(s.deadline_days)} в ${s.deadline_time_msk}`)}
                </td>
                <td>{s.is_default ? '✓' : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
